const WhiteLabelledMerchants = () => {
	return <div>WhiteLabelledMerchants</div>;
};

export default WhiteLabelledMerchants;
